<div class="container">
  <p (click)="useLanguage('en')" [ngClass]="{ 'option': true, 'active': activeLang === 'en' }">eng</p>
  <p class="divider">|</p>
  <p (click)="useLanguage('pt')" [ngClass]="{ 'option': true, 'active': activeLang === 'pt' }">port</p>
</div>
